import { AssetLookup } from './asset-lookup.interface.';

export const IesAdditionalAssetTypes: { [name: string]: AssetLookup } = {
  giveAway: {
    displayValue: 'Give away',
    order: 1,
    documentTypes: [],
    subTypes: {
      giveAwayValue: {
        displayValue: 'Current value of give away',
      },
    },
    isOptional: false,
    needSupportDocument: false,
  },
  vehicle: {
    order: 2,
    displayValue: 'Vehicles',
    documentTypes: [],
    subTypes: {
      vehicle: {
        displayValue: 'Vehicle',
      },
    },
    isOptional: false,
    needSupportDocument: false,
  },
  recreationalVehicle: {
    order: 3,
    displayValue: 'Recreational vehicles',
    documentTypes: [],
    subTypes: {
      recreationalVehicle: {
        displayValue: 'Recreational vehicle',
      },
    },
    isOptional: false,
    needSupportDocument: false,
  },
  farm: {
    order: 4,
    displayValue: 'Farms',
    documentTypes: [],
    subTypes: {
      farmValue: {
        displayValue: 'Current value of farm assets',
      },
      landValue: {
        displayValue: 'Current value of land other than the home quarter section',
      },
    },
    isOptional: false,
    needSupportDocument: false,
  },
  business: {
    displayValue: 'Businesses',
    order: 5,
    tips: 'Business assets or property, such as vehicles and equipment.',
    documentTypes: [],
    subTypes: {
      businessValue: {
        displayValue: 'Current value of business',
      },
    },
    isOptional: false,
    needSupportDocument: false,
  },
  property: {
    order: 6,
    displayValue: 'Properties',
    documentTypes: [],
    subTypes: {
      homePrincipleResidence: {
        displayValue: 'Home/principle residence',
      },
      recreationProperty: {
        displayValue: 'Recreation property',
      },
      rentalProperty: {
        displayValue: 'Rental property',
      },
    },
    isOptional: false,
    needSupportDocument: false,
  },
  other: {
    displayValue: 'Other',
    order: 7,
    documentTypes: [],
    subTypes: {
      otherValue: {
        displayValue: 'Current value of other',
      },
    },
    isOptional: false,
    needSupportDocument: false,
  },
};
